/** @jsx jsx */
import React from 'react';
import { cssMap, jsx } from '@compiled/react';
import { Text } from '@atlaskit/primitives/compiled';
import WarningIcon from '@atlaskit/icon/core/status-warning';
import Link from '@atlaskit/link';
import { token } from '@atlaskit/tokens';
import { useIntl, defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	title: {
		id: 'deprecation.banner.title',
		defaultMessage: 'Overviews are going away',
		description: 'Title of the overviews deprecation section message',
	},
	text: {
		id: 'deprecation.banner.text',
		defaultMessage:
			'Overviews are being deprecated by the end of 2025. Other options are available to view cross-project work at a glance. Your data will not be deleted as part of this change.',
		description: 'Description of the overviews deprecation section message',
	},
	link: {
		id: 'deprecation.banner.linkText',
		defaultMessage: 'Learn more',
		description: 'Link sending users to learn more about overviews deprecation',
	},
});

const styles = cssMap({
	root: {
		flex: 'none',
		display: 'flex',
		paddingBlock: token('space.100'),
		font: token('font.body'),
		color: token('color.text'),
	},
	container: {
		display: 'flex',
		gap: token('space.100'),
		backgroundColor: token('color.background.warning'),
		paddingInline: token('space.200'),
		paddingBlockStart: token('space.150'),
		paddingBlockEnd: token('space.200'),
		borderRadius: token('radius.small'),
		flexDirection: 'column',
	},
	firstRow: {
		display: 'flex',
		gap: token('space.100'),
		alignItems: 'center',
		fontWeight: token('font.weight.semibold'),
	},
});

const DeprecationMessage = () => {
	const { formatMessage } = useIntl();

	return (
		<div css={styles.root}>
			<div css={styles.container}>
				<div css={styles.firstRow}>
					<WarningIcon label="" color={token('color.icon.warning')} />
					{formatMessage(messages.title)}
				</div>
				<Text as="p">
					{formatMessage(messages.text)}{' '}
					<Link
						target="_blank"
						href="https://community.atlassian.com/forums/Jira-articles/Deprecation-notice-We-re-removing-Overviews-for-more-powerful/ba-p/3146942#M21416"
					>
						{formatMessage(messages.link)}
					</Link>
				</Text>
			</div>
		</div>
	);
};

export default DeprecationMessage;
